export default "__VITE_ASSET__ChO26Ems__"